<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('global.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.origin"
          :items="ticketoriginSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('ticket.ticketorigin')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.customer"
          :items="customerSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.product.customer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="contracttypeSelectItems"
            v-model="item.product_sub_contracts_sub_type"
            :items="contracttypeSelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('contract.contracttype')"
            item-text="name"
            item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.status"
          :items="ticketstatusSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('ticket.ticketstatus')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.bugType"
          :items="bugtypeSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('ticket.bugtype')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="machineSelectItems"
          v-model="item.product_sub_machine"
          :items="machineSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="toolheadSelectItems"
          v-model="item.product_sub_toolhead"
          :items="toolheadSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.toolhead')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="materialSupplySelectItems"
          v-model="item.product_sub_materialSupply"
          :items="materialSupplySelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.materialsupply')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="industrialComputerSelectItems"
          v-model="item.product_sub_industrialComputer"
          :items="industrialComputerSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.industrialcomputer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="controlUnitSelectItems"
          v-model="item.product_sub_controlUnit"
          :items="controlUnitSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.controlunit')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="accessorySelectItems"
          v-model="item.product_sub_accessory"
          :items="accessorySelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.accessory')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="softwareVersionSelectItems"
          v-model="item.product_sub_softwareVersion"
          :items="softwareVersionSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.softwareversion')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
        v-if="operatingSystemSelectItems"
          v-model="item.product_sub_operatingSystem"
          :items="operatingSystemSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          multiple
          :label="$t('qualitycheck.product.operatingsystem')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.assigned"
          :items="userSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('ticket.assigned')"
          item-text="login"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-col cols="12" sm="6" md="6">
          <h3> {{ $t('ticket.timeWork') }}</h3>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="item.timeWork_gte"
                :label="$t('global.min')"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="item.timeWork_lte"
                :label="$t('global.max')"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.tags"
          :items="tagSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('ticket.tags')"
          item-text="name"
          item-value="@id"
          color="primary"
          chips

          >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-if="item === Object(item)"
              v-bind="attrs"
              color="primary"
              :input-value="selected"
              label
            >
              <span class="pr-2">
                {{ item.name }}
              </span>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item.priority"
          :items="prioritySelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('priority.priority')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('global.createdat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.created_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.created_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('global.updatedat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.updated_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.updated_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('ticket.datebug') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.dateBug_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.dateBug_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('ticket.dateend') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.dateEnd_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.dateEnd_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">

        <v-row align="center">
          <v-col md="8" >
            <strong class="ml-4" >{{ $t('ticket.newrelease') }}:</strong>
          </v-col>
          <v-col md="4">
            <v-switch
              v-model="item.newrelease"
            ></v-switch>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'TicketFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  components: {
    InputDate,
  },
  data() {
    return {
      productTypeDatas: [],
    };
  },
  mounted() {
      this.tagGetSelectItems();
      this.ticketoriginGetSelectItems();
      this.ticketstatusGetSelectItems();
      this.customerGetSelectItems();
      this.bugtypeGetSelectItems();
      this.userGetSelectItems();
      this.priorityGetSelectItems();

      this.machineGetSelectItems();
      this.toolheadGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.controlUnitGetSelectItems();
      this.accessoryGetSelectItems();
      this.optionGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.contracttypeGetSelectItems();


  },

  computed: {
    ...mapFields('tag', {
      tagSelectItems: 'selectItems',
    }),
    ...mapFields('ticketorigin', {
      ticketoriginSelectItems: 'selectItems',
    }),
    ...mapFields('ticketstatus', {
      ticketstatusSelectItems: 'selectItems',
    }),
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
    }),
    ...mapFields('bugtype', {
      bugtypeSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems',
    }),
    ...mapFields('priority', {
      prioritySelectItems: 'selectItems',
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems',
    }),
    ...mapFields('materialsupply', {
      materialSupplySelectItems: 'selectItems',
    }),
    ...mapFields('industrialcomputer', {
      industrialComputerSelectItems: 'selectItems',
    }),
    ...mapFields('operatingsystem', {
      operatingSystemSelectItems: 'selectItems',
    }),
    ...mapFields('controlunit', {
      controlUnitSelectItems: 'selectItems',
    }),
    ...mapFields('accessory', {
      accessorySelectItems: 'selectItems',
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
    }),
    ...mapFields('softwareversion', {
      softwareVersionSelectItems: 'selectItems',
    }),
    ...mapFields('contracttype', {
      contracttypeSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      tagGetSelectItems: 'tag/fetchSelectItems',
      ticketoriginGetSelectItems: 'ticketorigin/fetchSelectItems',
      ticketstatusGetSelectItems: 'ticketstatus/fetchSelectItems',
      customerGetSelectItems: 'customer/fetchSelectItems',
      bugtypeGetSelectItems: 'bugtype/fetchSelectItems',
      userGetSelectItems: 'user/fetchSelectItems',
      priorityGetSelectItems: 'priority/fetchSelectItems',
      machineGetSelectItems: 'machine/fetchSelectItems',
      toolheadGetSelectItems: 'toolhead/fetchSelectItems',
      materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems',
      industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems',
      operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems',
      controlUnitGetSelectItems: 'controlunit/fetchSelectItems',
      accessoryGetSelectItems: 'accessory/fetchSelectItems',
      optionGetSelectItems: 'option/fetchSelectItems',
      softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems',
      contracttypeGetSelectItems: 'contracttype/fetchSelectItems',
    }),
  }
};
</script>
